import { useCallback, useState } from 'react'
import { routes } from '@/routes'
import { useLocales } from '@sevenrooms/locales'
import { useNavigation } from '@sevenrooms/navigation'
import { Button } from '@sevenrooms/ui-kit/form'
import { VStack } from '@sevenrooms/ui-kit/layout'
import { useCancelRequestMutation } from '../../../domain/request'
import { useAlertsRoute, useReservationsRoute } from '../../../hooks'
import { reservationWidgetMessages } from '../../../reservationWidgetMessages'
import { useModals } from '../../../store'
import { PriorityAlertDetails } from '../PriorityAlertDetails'

export function PriorityAlert() {
  const { showErrorModal } = useModals()
  const { push } = useNavigation()
  const { venueKey } = useReservationsRoute()
  const { formatMessage } = useLocales()
  const { requestId, partySize, startTime, endTime, date } = useAlertsRoute()
  const [isCancelDisabled, setCancelDisabled] = useState(!requestId)

  const [cancelRequest] = useCancelRequestMutation()

  const onCancelAlertClick = useCallback(async () => {
    try {
      setCancelDisabled(true)
      await cancelRequest({ requestId }).unwrap()
      push(routes.reservations.alerts.canceled, {
        params: { venueKey },
      })
    } catch (e) {
      showErrorModal()
    } finally {
      setCancelDisabled(false)
    }
  }, [cancelRequest, push, requestId, showErrorModal, venueKey])

  return (
    <VStack spacing="m" width="100%">
      <PriorityAlertDetails partySize={partySize} date={date} startTime={startTime} endTime={endTime} />
      <Button
        variant="secondary-warning"
        data-test="alert-cancel-button"
        fullWidth
        disabled={isCancelDisabled}
        onClick={onCancelAlertClick}
      >
        {formatMessage(reservationWidgetMessages.resCancelPageCancelPriorityAlertsButton)}
      </Button>
    </VStack>
  )
}
